import { InputRule } from '@tiptap/core';
import DragHandle from '@tiptap/extension-drag-handle';
import HorizontalRule from '@tiptap/extension-horizontal-rule';
import TiptapLink from '@tiptap/extension-link';
import Placeholder from '@tiptap/extension-placeholder';
import TiptapUnderline from '@tiptap/extension-underline';
import StarterKit from '@tiptap/starter-kit';
import { __ } from '@wordpress/i18n';
import { Markdown } from 'tiptap-markdown';
import { PlusButton } from './plus-button';

const PlaceholderExtension = Placeholder.configure({
	placeholder: ({ node }) => {
		if (node.type.name === 'heading') {
			return `Heading ${node.attrs.level}`;
		}
		return __('Type "/" for commands', 'allcoach');
	},
	includeChildren: true,
});

const MarkdownExtension = Markdown.configure({
	html: false,
	transformCopiedText: true,
});

// const BubbleMenuExtension = BubbleMenu.configure({
// 	element: document.createElement('div'),
// 	shouldShow: ({ editor, view, state, oldState }) => {
// 		return (
// 			editor.isActive('paragraph') ||
// 			editor.isActive('heading') ||
// 			editor.isActive('blockquote') ||
// 			editor.isActive('codeBlock')
// 		);
// 	},
// });

export * from './slash-command';
export {
	// BubbleMenuExtension as BubbleMenu,
	DragHandle,
	HorizontalRule,
	InputRule,
	MarkdownExtension,
	PlaceholderExtension as Placeholder,
	PlusButton,
	StarterKit,
	TiptapLink,
	TiptapUnderline,
};
